// removed by extract-text-webpack-plugin
module.exports = {"archived-event-panel":"archived-event-modal__archived-event-panel__2SWth","archived-event-wrapper":"archived-event-modal__archived-event-wrapper__18UIG","event-inner":"archived-event-modal__event-inner__3jw-o","event-flyer":"archived-event-modal__event-flyer__Zb3HM","event-information":"archived-event-modal__event-information__1u5KU","event-name":"archived-event-modal__event-name__2_qJD","event-host":"archived-event-modal__event-host__sUnTS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/event/EventList/ArchivedEventModal/archived-event-modal.scss
// module id = 1741
// module chunks = 1